import React, { useEffect } from 'react';
import cx from 'classnames';
import styles from '../../Select.module.scss';
import OptionsListProps from './OptionsList.types';
import Spinner from '../../../Spinner';

const OptionsList = ({
  options = [],
  selectValue,
  optionsOpen,
  disabled = false,
  search = false,
  emptyOption = null,
  handleSelect,
  handleKeyDown,
  handleFocus,
  graphicalSelect,
  optionsContainer,
  closeOptions,
  onBlur,
  isLoading = false,
  id,
}: OptionsListProps) => {
  const handleClickOutside = (event) => {
    const isOutside = graphicalSelect.current && !graphicalSelect.current.contains(event.target);
    if (isOutside) {
      closeOptions();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const loadingText = isLoading ? (
    <div className={styles.loaderOption}>
      <span className={styles.loadingText}>Loading</span>
      <span className={styles.spinnerHolder}>
        <Spinner className={styles.spinner} />
      </span>
    </div>
  ) : null;

  if (options.length === 0) {
    return (
      <div
        className={cx(styles.optionsContainer, styles.nonSearchable, styles.nonInteractive, {
          [styles.searchOptions]: search,
          [styles.visible]: optionsOpen,
        })}>
        <div
          className={cx(styles.graphicalSelect, {
            [styles.visible]: optionsOpen,
            [styles.disabled]: true,
          })}>
          {loadingText || emptyOption || 'No Match'}
        </div>
      </div>
    );
  }

  return (
    <div
      id={id}
      className={cx(
        styles.optionsContainer,
        styles.nonSearchable,
        styles.optionsContainer,
        { [styles.visible]: optionsOpen },
        { [styles.searchOptions]: search }
      )}
      onBlur={onBlur}
      ref={optionsContainer}>
      {options?.map((option, index) => {
        const text = typeof option !== 'string' ? option?.title : option;
        const value = typeof option !== 'string' ? `${option?.const === null ? '' : option?.const}` : option;
        const key =
          typeof option !== 'string'
            ? `${option?.const === null ? 'nullOption' : option?.const}${option?.title}-${index}`
            : `${option}-${index}`;
        return (
          <div
            className={cx(styles.graphicalSelect, {
              [styles.disabled]: disabled,
            })}
            key={key}
            onClick={() => !disabled && handleSelect(value, text)}
            role='option'
            aria-selected={selectValue === value}
            tabIndex={-1}
            onKeyDown={(event) => handleKeyDown(event, value, text)}
            onFocus={handleFocus}
            data-value={value}
            data-text={text}>
            {text}
          </div>
        );
      })}
    </div>
  );
};

export default OptionsList;
